import { Box, Stack, Typography } from "@mui/material";
import RecipeTable from "../../ProductionChart/components/RecipeTable";
import emptyIcon from "../../../assets/images/Icons/search-table.png";

export const OtherRecipes = (props) => {
  const { selectedOptionRecipe, globalData } = props;

  return (
    <Box>
      {selectedOptionRecipe ? (
        <RecipeTable recipe={selectedOptionRecipe} globalData={globalData} />
      ) : (
        <Stack
          sx={{
            flex: 1,
            flexShrink: 1,
            height: "calc(100dvh - 160px)",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <img src={emptyIcon} alt="empty" height={56} width={56} />
          <Typography
            sx={{
              fontWeight: 400,
              fontSize: "14px",
              color: "#485364",
              width: "500px",
              textAlign: "center",
            }}
          >
            No recipe selected yet.
          </Typography>
        </Stack>
      )}
    </Box>
  );
};
